import { useQuery } from '@tanstack/react-query';

import { getBrioEmployees, type GetBrioEmployeesResponse } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import type { QueryOptions } from '@/types/react-query';

import queryKeys from '../queryKeys';

export default function useBrioEmployees(
  options?: QueryOptions<GetBrioEmployeesResponse['items']>,
) {
  return useQuery({
    queryKey: queryKeys.employees.list('brio', undefined),
    queryFn: async () => {
      const result = await getBrioEmployees({}, wgApi);

      return result.items;
    },
    ...options,
  });
}
